import { useState, useRef, useEffect } from "react"
import { createPortal } from "react-dom"

export const IconDropdown = ({ value, options, onChange, label, icon, width }) => {
    const [isOpen, setIsOpen] = useState(false)
    const [dropdownPosition, setDropdownPosition] = useState({ top: 0, left: 0 })
    const iconRef = useRef(null)

    useEffect(() => {
        if (isOpen && iconRef.current) {
            const rect = iconRef.current.getBoundingClientRect()
            const dropdownHeight = Math.min(options.length * 48, 300) // approximate height based on options

            // Calculate available space from viewport edges
            const spaceBelow = window.innerHeight - rect.bottom
            const spaceAbove = rect.top

            // Determine vertical position
            let top
            if (spaceBelow >= dropdownHeight) {
                // Enough space below, open downward
                top = rect.bottom + window.scrollY + 8
            } else if (spaceAbove >= dropdownHeight) {
                // Not enough space below but enough above, open upward
                top = rect.top + window.scrollY - dropdownHeight - 8
            } else {
                // Not enough space either way, choose the side with more space
                if (spaceBelow > spaceAbove) {
                    top = rect.bottom + window.scrollY + 8
                } else {
                    top = rect.top + window.scrollY - dropdownHeight - 8
                }
            }

            // Position dropdown aligned to the right of the icon
            setDropdownPosition({
                top: top,
                left: rect.right + window.scrollX - 160, // 160px is the dropdown width, align right edge
            })
        }
    }, [isOpen, options.length])

    const handleClose = () => {
        setIsOpen(false)
    }

    const dropdown = isOpen && createPortal(
        <>
            <div
                className="fixed inset-0 z-[9998]"
                onClick={handleClose}
            />
            <div
                className="absolute z-[9999] bg-theme_clr1 rounded-xl shadow-lg w-[160px]"
                style={{
                    top: `${dropdownPosition.top}px`,
                    left: `${dropdownPosition.left}px`,
                }}
            >
                <div className="max-h-[300px] overflow-y-auto overflow-x-hidden">
                    {options.map((option) => (
                        <button
                            key={option}
                            onClick={() => {
                                onChange(option)
                                handleClose()
                            }}
                            className={`w-full text-left px-4 py-2.5 text-white text-sm hover:bg-theme_clr2 transition-colors whitespace-nowrap overflow-hidden text-ellipsis ${value === option ? 'bg-theme_clr2' : ''
                                }`}
                        >
                            {option}
                        </button>
                    ))}
                </div>
            </div>
        </>,
        document.body
    )

    return (
        <>
            <div
                ref={iconRef}
                onClick={() => setIsOpen(!isOpen)}
                className="hover:opacity-80 transition-opacity cursor-pointer shrink-0 flex items-center justify-center"
            >
                <img
                    src={icon}
                    alt={label}
                    style={{ width, height: width }}
                    className="shrink-0"
                />
            </div>
            {dropdown}
        </>
    )
}